import { Component, OnInit } from '@angular/core';
import { AbsenceGroupStoreService } from '../../storage/absence-group-store.service';

@Component({
    selector: 'app-absence-review',
    templateUrl: './absence-review.component.html',
    providers: [AbsenceGroupStoreService],
    standalone: false
})
export class AbsenceReviewComponent implements OnInit {

  constructor(private absenceGroupStore: AbsenceGroupStoreService) { }

  ngOnInit(): void {
    // Reload this store instance via the approval endpoint (subordinates' open absences).
    this.absenceGroupStore.forApproval = true;
    this.absenceGroupStore.loadAbsenceGroups();
  }
}
